import { useQuery } from '@tanstack/react-query';

import { listAdminAccounts } from 'api/adminAccounts';
import { queryKeys } from 'constants/queryKeys';
import { accountManagementStrings } from 'constants/strings';
import { useAuth } from 'contexts/AuthContext';
import type { TAdminAccount } from 'types';
import { toErrorMessage } from './utils';

type UseAdminAccountsResult = {
  accounts: TAdminAccount[];
  loading: boolean;
  error: string | undefined;
};

export function useAdminAccounts(): UseAdminAccountsResult {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: [queryKeys.ADMIN_ACCOUNTS, user?.uid],
    enabled: Boolean(user?.uid),
    queryFn: listAdminAccounts,
    retry: false,
  });

  return {
    accounts: query.data ?? [],
    loading: Boolean(user?.uid) && query.isPending,
    error: query.error
      ? toErrorMessage(
          query.error,
          accountManagementStrings.errors.loadAccountsFailed,
        )
      : undefined,
  };
}
